import api from '@/api/_cca-mobile';
import { showToast } from '@/utils/notifications';
import ManageConstante from '@/views/consultations/en-cours/constantes/manage-constante';
import $ from 'jquery';

export default {
    name: 'constantes',
    components: {
        ManageConstante
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            modal_toggler: 0,
            selected_constant: {},
            data_to_be_deleted: {},

            selectedConstante: undefined,
            isSharingConstante: false,
        };
    },

    watch: {
        evolution_toggler() {
            this.refreshConstantes()
        }
    },

    computed: {
        consultation_constantes() {
            return this.$store.getters["consultation_constantes"];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },

        selected_consultation_encours() {
            return this.$store.getters['selected_consultation_encours']
        },
    },

    async mounted() {
        this.refreshConstantes()
    },

    methods: {
        refreshConstantes() {
            this.is_loading = true

            let data = {
                consultation_id: this.consultation.id,
                type_consultation_id: this.consultation.tarif_consultation.type_consultation_id,
                evolution_id: this.evolution_id_initiale,
                est_en_cours: true 
            }

            this.$store.dispatch('getConsultationConstante', data).then(() => {
                if (this.consultation_constantes.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }

                this.is_loading = false
            })
        },

        addConstante() {
            this.modal_toggler = (this.modal_toggler === 0)?1:0

            this.selected_constant = {
                constante_group_id: 0
            }
        },

        editConstant(cste) {
            this.modal_toggler = (this.modal_toggler === 0)?1:0
            this.selected_constant = cste
        },

        removeGroupConstante(constante) {
            this.data_to_be_deleted = {
                libelle: constante.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.userCredentials.id,
                group_id: constante.constante_group_id
            }
        },

        async handleConfirmSharing(){
             this.isSharingConstante = true;

             try {
                 const response = await api.shareConstante(this.selectedConstante.reference);

                 if (response && response.status === 200) {
                     showToast("Constantes(s) partagée(s) avec succès")
                 }
             } catch (error) {
                 if (error.response) {
                     if (error.response.status === 400 || error.response.status === 422) {
                         showToast("Erreur de requête", 'error')
                     } else if (error.response.status === 500) {
                         showToast("Une erreur s'est produitre, veuillez réessayer plustard", 'error')
                     }
                 }
             } finally {
                 this.isSharingConstante = false;

                 $('.modal').modal('hide');
             }
         }
    }
}


